import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { REFERENCE_LINKS_PREFIX } from '../constants';
import css from './ReferenceLinkStatusChip.css';

// Maps a backend access status (see GoogleDocsReader.AccessStatus) to its chip presentation.
const STATUS_META = {
    accessible: { className: css.statusVerified, labelKey: 'STATUS_VERIFIED' },
    not_shared: { className: css.statusWarning, labelKey: 'STATUS_NOT_SHARED' },
    export_blocked: { className: css.statusWarning, labelKey: 'STATUS_EXPORT_BLOCKED' },
    export_too_large: { className: css.statusWarning, labelKey: 'STATUS_EXPORT_TOO_LARGE' },
    not_exportable: { className: css.statusWarning, labelKey: 'STATUS_NOT_EXPORTABLE' },
    invalid_url: { className: css.statusError, labelKey: 'STATUS_ERROR' },
    unavailable: { className: css.statusError, labelKey: 'STATUS_ERROR' },
};

const ReferenceLinkStatusChip = ({ status, serviceAccountEmail = null, translate }) => {
    const meta = STATUS_META[status];
    if (!meta) return null;
    return (
        <span className={classNames(css.statusChip, meta.className)}>
            {translate(`${REFERENCE_LINKS_PREFIX}.${meta.labelKey}`, { email: serviceAccountEmail || '' })}
        </span>
    );
};

ReferenceLinkStatusChip.propTypes = {
    status: PropTypes.string,
    serviceAccountEmail: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default ReferenceLinkStatusChip;
